import React, { useEffect, useState } from 'react';
import Banner from './components/Banner';
import NftBanner3 from 'assets/img/nfts/NftBanner3.png';
import AvatarSimmple from 'assets/img/avatars/avatarSimmmple.png';
import Calendar from '../main/applications/Calendar';
import Team from './Team/index';
import AllTeams from './components/AllTeams';
import TeamAccessRestriction from 'components/access/TeamAccessRestriction';
import Loader from 'components/loaders/Loader';
import { checkSubscriptionHistory } from 'api';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/authContext';

const TeamsHome = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [showRestriction, setShowRestriction] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);
  const location = useLocation();
  const { user, profileLoading } = useAuth();

  useEffect(() => {
    const checkAccess = async () => {
      if (profileLoading || !user?.id) return;
      try {
        const historyData = await checkSubscriptionHistory([user.id]);
        console.log('Subscription History Response:', historyData);

        const userHistory = historyData.find((data) => data.userId === user.id);

        // User has access if they have EVER subscribed before (regardless of current status)
        if (userHistory?.hasEverSubscribed === true) {
          setHasSubscription(true);
          setShowRestriction(false);
          console.log('User has subscription history - granting access');
        } else {
          setHasSubscription(false);
          // Only show restriction for "My Team" tab (tab 1) if user doesn't have subscription
          if (activeTab === 1) {
            setShowRestriction(true);
          }
          console.log('User has no subscription history - restricting access');
        }
      } catch (error) {
        console.error('Error checking subscription history:', error);
        // On error, default to allowing access to avoid blocking users
        setHasSubscription(true);
        setShowRestriction(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAccess();
  }, [user, profileLoading, activeTab]);

  // Handle tab changes and check if restriction should be shown
  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
    
    // Only show restriction for "My Team" tab (tab 1) if user doesn't have subscription
    if (!hasSubscription && tabNumber === 1) {
      setShowRestriction(true);
    } else {
      setShowRestriction(false);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 1:
        return <Team />;
      case 2:
        return <AllTeams />;
      case 3:
        return <Calendar />;
      default:
        return <Team />;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestedTab = params.get('tab');
    if (requestedTab) {
      const tabNumber = Number(requestedTab);
      setActiveTab(tabNumber);
      
      // Check if restriction should be shown for the requested tab
      if (!hasSubscription && tabNumber === 1) {
        setShowRestriction(true);
      } else {
        setShowRestriction(false);
      }
    }
  }, [location, hasSubscription]);

  return (
    <div className="mt-3 flex h-full w-full flex-col gap-5 rounded-[20px] xl:flex-row">
      <div className="h-full w-full rounded-[20px] transition-all duration-300">
        <div className="relative">
          <Banner
            image={NftBanner3}
            profile={AvatarSimmple}
            wallet="MyWallet420"
            address="simmple.web"
            name="Simmple"
            dat="Joined 17 Nov 2019"
            activeTab={activeTab}
            onTabChange={handleTabChange}
            hasSubscription={hasSubscription}
          />
        </div>
        
        <div className="mt-5 w-full grid grid-cols-1 gap-5">
          {/* Only show main loading for initial subscription check, not for tab content */}
          {isLoading ? (
            <div className="bg-white dark:bg-navy-800 rounded-[20px] shadow-shadow-100 dark:shadow-none border border-gray-100 dark:border-navy-700 overflow-hidden relative min-h-[600px]">
              <div className="flex items-center justify-center h-full min-h-[600px]">
                <Loader text="Loading teams..." fullScreen={false} />
              </div>
            </div>
          ) : (
            <div className="bg-white dark:bg-navy-800 rounded-[20px] shadow-shadow-100 dark:shadow-none border border-gray-100 dark:border-navy-700 overflow-hidden relative">
              {renderContent()}
              
              {/* Access Restriction Overlay - Only for "My Team" tab */}
              {showRestriction && activeTab === 1 && (
                <TeamAccessRestriction
                  message="To access team management features and create/manage your own teams, you need to subscribe to our course at least once. Previous subscriptions (even if expired) will grant you access."
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamsHome;